module.exports = __webpack_public_path__ + "static/media/country_mz.72d0d5ef.webp";